import { FC, forwardRef, PropsWithChildren } from 'react';
import { Box, SxProps } from '@mui/material';
import { clsx } from '@sweatpals/react-ui-kit';

export interface ImageWrapperType extends PropsWithChildren {
	sx?: SxProps;
}

// TODO: RD-2377 - delete this image wrapper and use the one in @sweatpals/react-ui-kit
const ImageWrapper: FC<ImageWrapperType> = forwardRef(({ children, sx }, ref) => (
	<Box component="div" sx={clsx({ display: 'inline-block', position: 'relative', flexShrink: '0' }, sx)} ref={ref}>
		{children}
	</Box>
));

ImageWrapper.displayName = 'ImageWrapper';

export default ImageWrapper;
